import React from 'react';
export const PartiallyCheckedIcon = _ref => {
  let {
    width = 20,
    height = 20
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: "".concat(width),
    height: "".concat(height),
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "21",
    height: "21",
    rx: "4.5",
    fill: "#6942F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "21",
    height: "21",
    rx: "4.5",
    stroke: "#6942F8"
  }));
};